import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { useModulos } from '@/shared/hooks/useModulos';
import type { Modulo } from '@/shared/services/modulosService';

/** Tela de bloqueio do módulo (só UX — o servidor bloqueia de verdade). */
export function ModuloGate({ modulo, children }: { modulo: Modulo; children: ReactNode }) {
  const { liberado, planoMinimo } = useModulos();
  if (liberado(modulo)) return <>{children}</>;
  const plano = planoMinimo(modulo);
  return (
    <div className="flex min-h-dvh items-center justify-center bg-gray-950 px-4">
      <div className="max-w-sm space-y-3 rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 text-center">
        <Lock className="mx-auto h-6 w-6 text-white/50" aria-hidden="true" />
        <h1 className="text-base font-semibold text-white">Recurso indisponível no seu plano</h1>
        <p className="text-sm text-slate-400">
          {plano ? `Disponível no plano ${plano}. ` : ''}Fale com o suporte para liberar.
        </p>
      </div>
    </div>
  );
}
